<template>
	<div class="swi-ban-home">
		<div class="swiper-wrapper">
			<router-link
				:to="item.has_story ? `/brandDetail/${item.banner_name}` : `/product?brand=${item.banner_name}`"
				class="swiper-slide" v-for="(item,index) in bannerList" :key="index">
				<img :src="item.img" alt="亚洲食品批发-美国华源食品集团, OCM Globe Inc -  Asian food wholesale USA">
			</router-link>
		</div>
		<!-- Add Pagination -->
		<div class="swiper-pagination"></div>
	</div>
</template>

<script>
import Swiper from "swiper"
import "swiper/dist/css/swiper.min.css"

export default {
	name: "swiperBanner",
	props: {
		bannerList: [Array]
	},
	data() {
		return {
			swiperInt: null
		}
	},
	mounted() {
		this.initSwiper()
	},
	methods: {
		initSwiper() {
			this.swiperInt = new Swiper('.swi-ban-home', {
				autoplay: {
					delay: 4000,
					disableOnInteraction: true,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			})
		}
	}
}
</script>

<style scoped lang="scss">
//swiperbanner
.swi-ban-home {
	overflow: hidden;
	position: relative;
	.swiper-slide img {
		display: block;
		width: 100%;
		cursor: pointer;
	}
	::v-deep {
		.swiper-pagination-bullet {
			width: 12px;
			height: 12px;
			border-radius: 50%;
			background: $black;
			opacity: 0.5;
			position: relative;
			margin: 0 12px !important;
			-webkit-transition: all 0.3s;
			-moz-transition: all 0.3s;
			-ms-transition: all 0.3s;
			-o-transition: all 0.3s;
			transition: all 0.3s;
		}
		.swiper-pagination-bullet:after {
			content: '';
			width: 24px;
			height: 24px;
			position: absolute;
			top: 50%;
			left: 50%;
			-webkit-transform: translate(-50%, -50%);
			-moz-transform: translate(-50%, -50%);
			-ms-transform: translate(-50%, -50%);
			transform: translate(-50%, -50%);
			border: 1px solid $black;
			border-radius: 50%;
			opacity: 0;
			-webkit-transition: all 0.3s;
			-moz-transition: all 0.3s;
			-ms-transition: all 0.3s;
			-o-transition: all 0.3s;
			transition: all 0.3s;
		}
		.swiper-pagination-bullet-active.swiper-pagination-bullet {
			opacity: 1;
		}
		.swiper-pagination-bullet-active.swiper-pagination-bullet:after {
			opacity: 1;
		}
		.swiper-pagination.swiper-pagination-bullets {
			bottom: 15px;
		}
	}
}
</style>
